import { render, staticRenderFns } from "./VirtualCategory.vue?vue&type=template&id=6ef3a67f&"
import script from "./VirtualCategory.vue?vue&type=script&lang=ts&"
export * from "./VirtualCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports